(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import Badge from "../../../../components/Badge";
import styles from "./CodeDetails.module.css";
import CodeDetailsHeading from "../CodeDetailsHeading";
import AvailabilityBadge from "../../../../components/AvailabilityBadge";

const CodeDetails = _ref => {
  var _details$children, _details$taxes;

  let {
    details,
    colors,
    isRtl,
    taxes,
    isFirstItem,
    isNextItemHasChildren,
    onApplyCode,
    isPreviousItemHasChildren
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, details.children ? /*#__PURE__*/React.createElement("div", {
    className: styles.codes
  }, isFirstItem ? /*#__PURE__*/React.createElement(CodeDetailsHeading, {
    description: details.description,
    showDescription: !!details.children,
    isUseActionAvailable: !!onApplyCode,
    taxes: taxes,
    isRtl: isRtl
  }) : /*#__PURE__*/React.createElement("div", {
    className: cx(styles.codeTitle, {
      [styles.rtl]: isRtl
    })
  }, details.description), (_details$children = details.children) === null || _details$children === void 0 ? void 0 : _details$children.map((cChild, idx) => /*#__PURE__*/React.createElement(CodeDetails, {
    details: cChild,
    onApplyCode: onApplyCode,
    isRtl: isRtl // eslint-disable-next-line react/no-array-index-key
    ,
    key: "".concat(cChild.code, "-").concat(idx),
    colors: colors
  }))) : /*#__PURE__*/React.createElement("div", {
    className: cx({
      [styles.widthNextItemChildren]: isNextItemHasChildren,
      [styles.widthPreviousItemChildren]: isPreviousItemHasChildren
    })
  }, isFirstItem && /*#__PURE__*/React.createElement(CodeDetailsHeading, {
    description: details.description,
    showDescription: !!details.children,
    isUseActionAvailable: !!onApplyCode,
    taxes: taxes,
    isRtl: isRtl
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.codeDetailsWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.codeDetails, {
      [styles.rtl]: isRtl
    })
  }, /*#__PURE__*/React.createElement(AvailabilityBadge, {
    isExist: details.isRestricted || details.isProhibited,
    isProhibited: details.isProhibited,
    className: cx(styles.availabilityBadge, {
      [styles.rtl]: isRtl
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.codeBadge
  }, /*#__PURE__*/React.createElement(Badge, {
    color: colors.success
  }, details.code)), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.codeDescription, {
      [styles.rtl]: isRtl
    })
  }, details.description, details.isProhibited && /*#__PURE__*/React.createElement("span", {
    className: styles.availabilityLabel
  }, "(".concat(t("Prohibited"), ")")), details.isRestricted && /*#__PURE__*/React.createElement("span", {
    className: styles.availabilityLabel
  }, "(".concat(t("Restricted by", {
    value: details.restrictionAuthority
  }), ")")))), /*#__PURE__*/React.createElement("div", {
    className: styles.taxWrap
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.taxes, {
      [styles.rtl]: isRtl
    })
  }, (_details$taxes = details.taxes) === null || _details$taxes === void 0 ? void 0 : _details$taxes.map(tax => /*#__PURE__*/React.createElement("div", {
    className: styles.tax,
    key: tax.tax
  }, tax.value === null ? "" : "".concat(tax.value, "%")))), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.uomWrapper, {
      [styles.rtl]: isRtl
    })
  }, details.uom && /*#__PURE__*/React.createElement("div", {
    className: styles.uom
  }, details.uom)))), !!onApplyCode && /*#__PURE__*/React.createElement("div", {
    className: styles.useBtnWrapper
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    onClick: () => onApplyCode(details.code),
    className: cx(styles.useBtn, {
      [styles.rtl]: isRtl
    })
  }, t("Apply"))))));
};

__signature__(CodeDetails, "useTranslation{{ t }}", () => [useTranslation]);

CodeDetails.propTypes = {
  details: PropTypes.shape({
    code: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    dutyRate: PropTypes.number,
    children: PropTypes.array,
    uom: PropTypes.string,
    taxes: PropTypes.array,
    isProhibited: PropTypes.bool,
    isRestricted: PropTypes.bool,
    restrictionAuthority: PropTypes.string
  }),
  colors: PropTypes.shape({
    success: PropTypes.string.isRequired,
    info: PropTypes.string.isRequired,
    secondary: PropTypes.string.isRequired
  }).isRequired,
  isRtl: PropTypes.bool,
  isFirstItem: PropTypes.bool,
  taxes: PropTypes.array,
  isNextItemHasChildren: PropTypes.bool,
  onApplyCode: PropTypes.func,
  isPreviousItemHasChildren: PropTypes.bool
};
CodeDetails.defaultProps = {
  details: {
    taxes: [],
    uom: ""
  },
  isRtl: false,
  isFirstItem: false,
  taxes: [],
  isNextItemHasChildren: false,
  onApplyCode: null,
  isPreviousItemHasChildren: false
};

const _default = /*#__PURE__*/React.memo(CodeDetails);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CodeDetails, "CodeDetails", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/CodeDetails/CodeDetails.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/CodeDetails/CodeDetails.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();